import { render, staticRenderFns } from "./VideoSwiper.vue?vue&type=template&id=eb5129ea&scoped=true&"
import script from "./VideoSwiper.vue?vue&type=script&lang=js&"
export * from "./VideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VideoSwiper.vue?vue&type=style&index=0&id=eb5129ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5129ea",
  null
  
)

export default component.exports